import { read } from '@/api/rest';

/**
 * @module api/admin-relation
 */
const adminRelation = {
  index: async (params) => await read(`/admin-relation?${params.toString()}`),
};

export default adminRelation;
